import { Suspense } from 'react';

import { lazyRoute } from 'src/routes/lazy-route';
import { Navigate, Outlet } from 'react-router-dom';
// auth
import { GuestGuard } from 'src/auth/guard';
// layouts
import AuthClassicLayout from 'src/layouts/auth/classic';
// components
import { SplashScreen } from 'src/components/loading-screen';

import { paths } from '../paths';

// ----------------------------------------------------------------------

// JWT
// const JwtLoginPage = lazyRoute(() => import('src/pages/auth/jwt/login'));

// FIREBASE
const FirebaseLoginPage = lazyRoute(() => import('src/pages/auth/firebase/login'));
const FirebaseForgotPasswordPage = lazyRoute(
  () => import('src/pages/auth/firebase/forgot-password'),
);
const FirebaseResetPasswordPage = lazyRoute(() => import('src/pages/auth/firebase/reset-password'));
// ----------------------------------------------------------------------

// NAT-2840: the legacy HTML listino pages (render target of the retired Doppio service) are gone.
// Old links go to the generic download; the target is a bare path, so ?data= tokens are dropped.
export const publicRoutes = [
  {
    path: paths.public.productPdfPreview,
    element: <Navigate to={paths.public.generic} replace />,
  },
  {
    path: paths.public.listinoPreview,
    element: <Navigate to={paths.public.generic} replace />,
  },
  {
    path: paths.root,
    element: (
      <GuestGuard>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </GuestGuard>
    ),
    children: [
      {
        path: paths.login,
        element: (
          <AuthClassicLayout>
            <FirebaseLoginPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: paths.forgotPassword,
        element: (
          <AuthClassicLayout>
            <FirebaseForgotPasswordPage />
          </AuthClassicLayout>
        ),
      },
      {
        path: paths.resetPassword,
        element: (
          <AuthClassicLayout>
            <FirebaseResetPasswordPage />
          </AuthClassicLayout>
        ),
      },
    ],
  },
];
